import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { RadioGroup, RadioGroupItem } from '~/lib/ui/radio-group'
import { useTranslation } from '../../hooks/useTranslation'

const AiOrGeneral = () => {
  const { uiState, setUiState } = usePracticeInterviewing()
  const { t } = useTranslation('PartTwoForm')
  return (
    <div className="flex flex-col pb-8">
      <label htmlFor="ayla_assisted">{t('would_you_like_ayla')}</label>
      <div className="flex gap-4 pb-4">
        <RadioGroup
          id="ayla_assisted"
          value={uiState.aiInterview}
          onValueChange={(value) =>
            setUiState((prev) => ({ ...prev, aiInterview: value }))
          }
        >
          <label>
            <RadioGroupItem value={true} className="mr-4" />
            {t('ayla_yes')}
          </label>
          <label>
            <RadioGroupItem value={false} className="mr-4" />
            {t('ayla_no')}
          </label>
        </RadioGroup>
      </div>
    </div>
  )
}

export default AiOrGeneral
